import React, { useEffect, useState } from 'react'
import { Spinner } from 'react-bootstrap'
import HorizontalCourseCard from '../HorizontalCourseCard/HorizontalCourseCard'
import CustomSearch from '../CustomSearch/CustomSearch'
import useClassi from '../../hooks/useClassi';
import { ROLES } from '../../model/roles';
import { useSelector } from 'react-redux';
import useMediaQuery from '../../hooks/useMediaQuery';
import { alertService } from '../../services/AlertService';
import CustomModal from '../CustomModal/CustomModal';
import useClassiUtenti from '../../hooks/useClassiUtenti';
import { TIPO_CORSO } from '../../model/tipoCorso';
import useCorsiUtenti from '../../hooks/useCorsiUtenti';
import UtilityService from '../../services/UtillityServices/UtilityService';
import { useNavigate } from 'react-router';

export default function AssegnaCorsiModal({selectedUser, setModalStateClassiUtenti, showModalCreateClassiUtenti, setSelectedUser}) {

  const { getClassiByParamsNoAuth } = useClassi();
  const { createClassiUtenti, loadingStateClassiUtenti, findClassiUtentiByUtente } = useClassiUtenti();
  const {
    assignCourseToUser,
    loadingStateCorsiUtenti
  } = useCorsiUtenti();

  const [selectedCourse, setSelectedCourse] = useState(null);
  const userLoggedIn = useSelector(state => state.user.userData);
  const [paymentOption, setPaymentOption] = useState('self');
  const [voucherOption, setVoucherOption] = useState("1");
  const [formAssegnaCorso, setFormAssegnaCorso] = useState({});
  const [corsiUtentiAssignedPerUser, setCorsiUtentiAssignedPerUser] = useState([]);
  const [localCorsiUtentiAssignedPerUser, setLocalCorsiUtentiAssignedPerUser] = useState([]);
  const isWideScreen = useMediaQuery('(min-width: 1200px)');
  const navigate = useNavigate();

  useEffect(() => {
    if(selectedUser && showModalCreateClassiUtenti) {
      fetchClassiUtentiByUtente();
    }
  }, [selectedUser, showModalCreateClassiUtenti]);

  const fetchClassiUtentiByUtente = async () => {
    if(selectedUser) {
      let response = await findClassiUtentiByUtente({id_utente: selectedUser.id_utente});
      const classiUtenti = response?.map(item => ({
        ...item,
        id_classe: item?.classe?.id_classe ?? null,
        data_inizio: item.classe.data_inizio,
        data_fine: item.classe.data_fine,
        denominazione: item.classe.denominazione
      }));
      setCorsiUtentiAssignedPerUser(classiUtenti);
    }
  }


  const handleFormChange = e => {
    const { name, value } = e.target;
    
    if (name === 'sconto') {
      const numValue = Number(value);
      if (numValue < 0) return;
      if (numValue > userLoggedIn?.sconto_default) return;
      if (!Number.isInteger(numValue)) return;
    }
    
    setFormAssegnaCorso(prevState => ({ ...prevState, [name]: value }));
  }

  const handleCloseModal = () => {
    setModalStateClassiUtenti(state => ({ 
      ...state,
      showModalCreateClassiUtenti: false
    }));
    setSelectedCourse(null);
    setCorsiUtentiAssignedPerUser([]);
    setLocalCorsiUtentiAssignedPerUser([]);
    setSelectedUser(null);
  }

  const onUpdateCorsiUtenti = async () => {
    let checkoutPartnerList = [];
    if (localCorsiUtentiAssignedPerUser?.length > 0) {
      for (const corsoAssigned of localCorsiUtentiAssignedPerUser) {
        if(corsoAssigned.pagamento_partner === "0") {
          const data = {
            pagamento_partner: corsoAssigned?.pagamento_partner ?? "0",
            sconto_corsista: corsoAssigned?.sconto_corsista ?? "0",
            sconto: corsoAssigned?.sconto, 
            id_classe: corsoAssigned?.id_classe,
            id_utente: selectedUser?.id_utente
        }
        await createClassiUtenti(data)
        } else {
          checkoutPartnerList.push({
            ...corsoAssigned,
            corsistaUsername: selectedUser?.username
          });
        }
      }
    } 

    if(checkoutPartnerList.length > 0) {
      navigate(`/checkout`, { state: { courseData: checkoutPartnerList } });
    }

    handleCloseModal();
    checkoutPartnerList = [];
  }

  const onAssignCourse = () => {
    
    if(selectedCourse) {
      const corsiUtentiCorsoType = corsiUtentiAssignedPerUser.filter(corso => corso?.tipo === "corso");
      if(corsiUtentiCorsoType.some(corso => corso?.corso?.id_corso === selectedCourse?.corso?.id_corso)) {
        alertService.warn("Il corso è già stato assegnato all'utente", {autoClose: true});
        return;
      }

      if (!corsiUtentiAssignedPerUser.some(corso => corso?.id_classe === selectedCourse?.id_classe)) {
        if(userLoggedIn?.role === ROLES.ADMIN || userLoggedIn?.role === ROLES.COURSE_DESIGNER || userLoggedIn?.role === ROLES.DEVELOPER){
          selectedCourse.stato_pagamento = formAssegnaCorso.stato_pagamento;
          if(selectedCourse.stato_pagamento !== "Non_pagato" && selectedCourse.stato_pagamento !== "Pagato" && selectedCourse.stato_pagamento !== "Parzialmente_pagato"){
            alertService.warn("Seleziona uno stato di pagamento del corso", {autoClose: true});
            return;
          }
        }
        
        if(userLoggedIn?.role === ROLES.PARTNER){
          selectedCourse.pagamento_partner = paymentOption == "corsista" ? "0" : "1";
          selectedCourse.sconto_corsista = (voucherOption == "1" && selectedCourse.pagamento_partner == "1") ? "0" : voucherOption;
          if(paymentOption == "corsista" && voucherOption == "1") {
            selectedCourse.sconto = formAssegnaCorso?.sconto;
          } else {
            delete formAssegnaCorso?.sconto;
            delete selectedCourse?.sconto;
          }
        }
        setCorsiUtentiAssignedPerUser(prev => [...prev, selectedCourse]);
        setLocalCorsiUtentiAssignedPerUser(prev => [...prev, selectedCourse]);
      } else {
        alertService.warn("Il corso è già stato assegnato all'utente", {autoClose: true});
      }
    } else {
      alertService.warn("Seleziona un corso da assegnare all'utente", {autoClose: true});
    }
  }

  const removeCourse = (classIdToRemove) => {
    setLocalCorsiUtentiAssignedPerUser(prevCourses => prevCourses.filter(course => course.id_classe !== classIdToRemove));
    setCorsiUtentiAssignedPerUser(prevCourses => prevCourses.filter(course => course.id_classe !== classIdToRemove));
  };

  const handlePaymentOptionChange = (e) => {
    setPaymentOption(e.target.value);
  };

  const handleVoucherOptionChange = (e) => {
    setVoucherOption(e.target.value);
  };

  const renderPartnerPaymentOptions = () => (
    <div className="col-12 my-3">
         <span className='small text-muted d-block mb-1'><b>Pagamento</b></span>
        <div className="btn-group d-flex gap-3" role="group" aria-label="Basic radio toggle button group">
              <input
                type="radio"
                className="btn-check"
                name="paymentOption"
                id="selfPayment"
                value="self"
                autoComplete="off"
                checked={paymentOption === 'self'}
                onChange={handlePaymentOptionChange}
              />
              <label className="btn btn-outline-primary" htmlFor="selfPayment">
                Pagamento a proprio carico
              </label>
  
              <input
                type="radio"
                className="btn-check"
                name="paymentOption"
                id="corsistaPayment"
                value="corsista"
                autoComplete="off"
                checked={paymentOption === 'corsista'}
                onChange={handlePaymentOptionChange}
              />
              <label className="btn btn-outline-primary" htmlFor="corsistaPayment">
                Pagamento a carico del corsista
              </label>
            </div>
    </div>
    )
  
    const renderPartnerVoucherOptions = () => (
    <div className="col-12 my-3">
         <span className='small text-muted d-block mb-1'><b>Applica sconto</b></span>
        <div className="btn-group d-flex gap-3" role="group" aria-label="Basic radio toggle button group">
              <input
                type="radio"
                className="btn-check"
                name="voucherOption"
                id="yes-voucher"
                value="1"
                autoComplete="off"
                checked={voucherOption === "1"}
                onChange={handleVoucherOptionChange}
              />
              <label className="btn btn-outline-primary" htmlFor="yes-voucher">
                Applica
              </label>
  
              <input
                type="radio"
                className="btn-check"
                name="voucherOption"
                id="no-voucher"
                value="0"
                autoComplete="off"
                checked={voucherOption === "0"}
                onChange={handleVoucherOptionChange}
              />
              <label className="btn btn-outline-primary" htmlFor="no-voucher">
                Non applicare
              </label>
            </div>
    </div>
    )

  const renderBody = () => (
    <>
    {
      !loadingStateClassiUtenti.isLoadingFindClassiUtentiByUtente ? (
      <div className='row'>
      <div className='col-sm-12 col-xl-6'>
      <CustomSearch
            field={"denominazione_corso"}
            label={"Cerca corso"}
            searchApi={getClassiByParamsNoAuth}
            placeholder={"Nome del corso"}
            selectedItem={selectedCourse}
            setSelectedItem={setSelectedCourse}
            showDate={true}
              />
              {selectedCourse && (
              <span className='d-block'>{selectedCourse?.corso?.denominazione}
              {
                selectedCourse?.corso?.modalita_erogazione !== TIPO_CORSO.TELEMATICA_ASINCRONA && (
                  <>
                  {" - "}{selectedCourse?.denominazione}{" - "}({selectedCourse?.data_inizio ? UtilityService.formatDate(selectedCourse?.data_inizio) : ""} - {selectedCourse?.data_fine ? UtilityService.formatDate(selectedCourse?.data_fine) : ""})
                  </>
                )
              }
              </span>
              )}
      {selectedCourse?.denominazione &&
      <>
       {
          (userLoggedIn?.role === ROLES.PARTNER) && (
            <>
            {renderPartnerPaymentOptions()}
            {
              paymentOption === "corsista" && (
                renderPartnerVoucherOptions()
              )
            }
            {
              paymentOption === "corsista" && voucherOption === "1" && (
                <div className="my-3">
                  <div className="alert alert-primary" role="alert">
                    <i className="bi bi-info-circle me-2"></i>
                    <small>
                      Lo sconto massimo applicabile è di <strong>{userLoggedIn?.sconto_default}€</strong>. 
                      La differenza tra lo sconto massimo e quello applicato costituirà la tua provvigione.
                    </small>
                  </div>
                  
                  <div className="form-group">
                    <span className='d-block text-muted mb-2'>
                      <b>Inserisci sconto per il corsista (in €)</b>
                    </span>
                    <input 
                      name="sconto" 
                      value={formAssegnaCorso.sconto || ''} 
                      onChange={handleFormChange} 
                      className="form-control" 
                      type="number"
                      min="0"
                      max={userLoggedIn?.sconto_default}
                      step="1" 
                      onKeyDown={(e) => {
                        if(['e', 'E', '+', '-', '.'].includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      placeholder={`Sconto massimo: ${userLoggedIn?.sconto_default}€`} 
                      aria-label="Sconto"
                    />
                    <small className="text-muted mt-1 d-block">
                      Esempio: se applichi uno sconto di 100€ su uno sconto massimo di 300€, la tua provvigione sarà di 200€
                    </small>
                  </div>
                </div>
              )
            }
            </>
            )
      }
      <div className='my-3'>
       <button className='btn btn-primary my-3 w-100' onClick={onAssignCourse}>Assegna corso</button>
     </div>
      </>
      }
      </div>
      <div className='col-sm-12 col-xl-6' style={{borderLeft: `${isWideScreen ? "1px solid #d8d8d8" : ""}`}}>
      {(corsiUtentiAssignedPerUser?.length > 0) ? (
        <>
          <span className='d-block text-muted'><b>Lista corsi di {selectedUser?.nome} {selectedUser?.cognome}</b></span>
          {corsiUtentiAssignedPerUser?.map(classe => (
            <div key={classe.id_classe}>
                  <HorizontalCourseCard
                    cardStyle={"shadow"} 
                    course={classe}
                    userLoggedIn={userLoggedIn}
                    selectedRole={"corsista"}
                  /*   isCreateUserView={true} */
                    onRemoveCourse={removeCourse}
                   partnerNewCorsi={localCorsiUtentiAssignedPerUser}
                  />
            </div>
          ))}
        </>
      ) : (
        <div className='mt-5 text-center'>
      <p className='text-muted'>Nessun corso assegnato all'utente.</p>
      <i className="bi bi-mortarboard fs-1 text-secondary"></i>
        </div>
      )}
    </div>
      </div>
    ) : (
      <div className='text-center'>
        <Spinner as="span" animation="border" size="xl" role="status" className="my-5"/>
      </div>
    )
    }
    </>
  )


  return (
    <CustomModal 
    show={showModalCreateClassiUtenti}
    onHide={handleCloseModal}
    headerText="Assegna corso"
    size={"xl"}
    btnText={"Salva"}
    body={renderBody()} 
    closeButton={true}
    isLoading={loadingStateClassiUtenti.isLoadingClassiUtentiCreating || loadingStateCorsiUtenti.isLoadingCorsiUtentiCreating}
    onUndoChanges={handleCloseModal} 
    onSave={onUpdateCorsiUtenti}
  />
  )
}
